<template>
    <section class="page-section bg-white" id="services">
      <div class="container">
        <div class="text-center">
          <h2 class="section-heading text-info text-uppercase">Servicios</h2>
          <h3 class="section-subheading text-muted">
            Conoce nuestros servicios de decoración para fiestas
          </h3>
        </div>
        <div class="row text-center">
          <div class="col-md-4">
            <a href="#portfolio"
              title="Ver variedad de piñatas"
             class="link-offset-2 link-underline link-underline-opacity-0">
              <span class="fa-stack fa-4x">
                <i class="fas fa-star fa-stack-2x text-info"></i>
                <i class="fas fa-magic fa-xs fa-stack-1x fa-inverse"></i> </span></a>
            <h4 class="my-3 text-danger">Elaboración de Piñatas</h4>
            <p class="text-muted">
              Conoce nuestra amplia variedad de piñatas artesanales
            </p>
          </div>
          <div class="col-md-4">
            <RouterLink to="decoraciones-para-fiestas.html#page-top" title="Decoraciones para fiestas">
              <span class="fa-stack fa-4x">
                <i class="fas fa-star fa-stack-2x text-success"></i>
                <i class="fas fa-user-astronaut fa-stack-1x fa-inverse"></i>
              </span>
            </RouterLink>
            <h4 class="my-3 text-danger">Decoración Temática</h4>
            <p class="text-muted">
              Creamos divertidas piñatas y decoraciones para fiestas Temáticas
            </p>
          </div>
          <div class="col-md-4">
            <RouterLink to="articulos-para-fiestas.html#page-top" title="Artículos para Fiestas">
              <span class="fa-stack fa-4x">
                <i class="fas fa-star fa-stack-2x text-primary"></i>
                <i class="fa fa-gift fa-sm fa-stack-1x fa-inverse"></i>
              </span>
            </RouterLink>
            <h4 class="my-3 text-danger">Artículos para Fiestas</h4>
            <p class="text-muted">
              Contamos con gran variedad de artículos decorativos como globos,
              piñatas, confeti, regalos etc..
            </p>
          </div>
        </div>
        <div class="text-center">
          <a class="btn btn-success btn-xl text-uppercase shadow" href="https://wa.me/5217772408608"
            title="Contáctanos por Whatsapp" target="_blank"><i class="fab fa-whatsapp"></i> Contáctanos</a>
        </div>
      </div>
    </section>
</template>
<script setup>
import { RouterLink } from 'vue-router';
</script>